import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { getTimeDiffText } from '../../helpers';
import OnboardingDaysButton from '../buttons/OnboardingDaysButton';
import dayjs from '../../config/dayjs';
import { getClosestFutureBusinessDay } from '../../helpers/date-to-pay-restrictions';

const ButtonDate = ({
  func,
  days,
  disableWeekend,
  holidayDates,
  showButtonSubtitle,
  label,
  id,
  variant,
  icon,
  detail,
  tooltipInfo,
  size,
}) => {
  const { dayToJump, isWeekend } = useMemo(() => {
    const requiredDate = dayjs().add(days, 'days');
    if (!disableWeekend) return { dayToJump: requiredDate, isWeekend: false };
    const businessDay = getClosestFutureBusinessDay(requiredDate, holidayDates);
    return {
      dayToJump: businessDay,
      isWeekend: !businessDay.isSame(requiredDate, 'day'),
    };
  }, [days, disableWeekend, holidayDates]);

  const onClick = useCallback((...args) => {
    func(dayToJump, isWeekend, ...args);
  }, [dayToJump, func, isWeekend]);

  return (
    <OnboardingDaysButton
      label={label || getTimeDiffText(dayToJump)}
      variant={variant}
      color="primary"
      id={id}
      onClick={onClick}
      showButtonSubtitle={showButtonSubtitle}
      labelVariant="small_2"
      subtitleVariant="small_1"
      buttonProps={{ sx: { mx: 'auto', width: '100%', px: 0, py: 0.25 } }}
      icon={icon}
      detail={detail}
      tooltipInfo={tooltipInfo}
      size={size}
    />
  );
};

ButtonDate.propTypes = {
  func: PropTypes.func.isRequired,
  days: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  disableWeekend: PropTypes.bool,
  holidayDates: PropTypes.instanceOf(Set),
  label: PropTypes.string,
  variant: PropTypes.string,
  icon: PropTypes.node,
  detail: PropTypes.node,
  tooltipInfo: PropTypes.string,
  showButtonSubtitle: PropTypes.bool,
  size: PropTypes.string,
};

ButtonDate.defaultProps = {
  disableWeekend: true,
  holidayDates: new Set(),
  label: null,
  variant: 'onboardingOutlined',
  icon: null,
  detail: null,
  tooltipInfo: null,
  showButtonSubtitle: true,
  size: '',
};

export default ButtonDate;
